import * as React from 'react';

import * as styles from './MoreFiltersModalContentLayout.css';

export const MoreFiltersModalContentLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const handleAnimationStart = (event: React.AnimationEvent) => {
    event.stopPropagation();
  };

  return (
    <div className={styles['container']} onAnimationStart={handleAnimationStart}>
      {children}
    </div>
  );
};
